export default "* Fugl\n* Kendetegn \n* Kamuflage";